<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import FundCluster from "@/components/modals/fund-cluster-list.vue";
import ItemCategory from "@/components/modals/item-category.vue";
import Supplier from "@/components/modals/supplier.vue";
import Unit from "@/components/modals/unit.vue";
import Employee from "@/components/modals/employee-hris.vue";
import Location from "@/components/modals/property-location.vue";
import XLSX from "xlsx";
import { saveAs } from "file-saver";
import PropertyCreate from "@/components/modals/property-create.vue";
import Details from "@/router/views/property/components/details";
import AssignmentHistory from "@/router/views/property/components/assignmenthistory";
import Attachments from "@/router/views/property/components/attachments";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  page: {
    title: "Pending"
  },
  components: {
    Layout,
    PageHeader,
    FundCluster,
    ItemCategory,
    Supplier,
    Unit,
    Employee,
    Location,
    PropertyCreate,
    Details,
    AssignmentHistory,
    Attachments,
    RawData
  },
  data() {
    return {
      title: "Pending",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Pending",
          active: true
        }
      ],
      tableData: [],
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptionsLg: [10, 25, 50, 100],
      pageOptionsSm: [5, 10, 20, 50],
      filter: "",
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "poNumber",
          sortable: true,
          label: "Purchase Order"
        }
      ],
      propertyFields: [
        {
          key: "Name",
          sortable: true
        }
      ],
      poIndex: -1,
      propertyIndex: -1,
      itemIndex: -1,
      tableBusy: false,
      editMode: false,
      nextPage: false,
      fundClusterId: "",
      itemCategory: "",
      employeeName: "",
      location: "",
      excelList: [],
      errorData: "",
      campusId: this.$store.state.data.selectedCampus.id,
      accountableEmployee: null,
      getEmployeeType: "",
      getLocationType: "",
      assignmentHistoryEmployeeData: null,
      assignmentHistoryLocationData: null
    };
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (this.bySearch) {
            if (item.name.toUpperCase().includes(this.filter.toUpperCase())) {
              return item.name
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.propertyNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            ) {
              return item.propertyNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.serialNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            ) {
              return item.serialNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.currentAssignment &&
              item.currentAssignment.assignmentNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            ) {
              return item.currentAssignment.assignmentNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            }
          } else {
            if (
              item.poNumber.toUpperCase().includes(this.filter.toUpperCase())
            ) {
              return item.poNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.supplier.toUpperCase().includes(this.filter.toUpperCase())
            ) {
              return item.supplier
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            }
          }
        });
      }
      return data;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    }
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
  },
  methods: {
    changeCampus(data) {
      this.campusId = data.id;
      this.getByPo();
    },
    getByPo() {
      this.tableBusy = true;
      this.$store
        .dispatch("property/GetPropertyPending", this.campusId)
        .then((res) => {
          let index = 0;
          res.data.forEach((item) => {
            item.id = `po-${index++}`;
            item.details = [];
            item.toggleAll = false;
            item.showDetails = false;
            item.rotateChevy = false;
            item.currentPage = 1;
            item.perPage = 5;
            item.filter = "";
            item.tableBusy = false;
          });
          this.tableData = res.data.sort((a, b) =>
            a.id < b.id ? 1 : -1
          );
          this.tableBusy = false;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting property list!",
            "error"
          );
        });
    },
    getProperty(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      row.item.showDetails = !row.item.showDetails;
      row.item.details = [];
      if (row.item.showDetails) {
        row.item.toggleAll = false;
        row.item.tableBusy = true;
        setTimeout(() => {
          var poNumber = row.item.poNumber;
          var status = "PENDING";
          var campusId = this.campusId;
          this.$store
            .dispatch("property/GetPropertybyPO", {
              poNumber,
              status,
              campusId
            })
            .then((res) => {
              res.data.forEach((item) => {
                item.visible = false;
                item.itemVisible = false;
                item.assignmentHistory = [];
                item.assignVisible = false;
                item.assignLoading = false;
                item.inspectionVisible = false;
                item.attachmentVisible = false;
                item.attachmentLoading = false;
                item.addDocu = false;
                item.fileSearch = "";
                item.propertyInspections.forEach((inspect) => {
                  inspect.inspectionFiles = [];
                  inspect.attachmentLoading = false;
                });
              });
              row.item.details = res.data;
              row.item.tableBusy = false;
            })
            .catch(() => {
              row.item.tableBusy = false;
              this.showToast(
                "Something went wrong - Getting property list!",
                "error"
              );
            });
        }, 1000);
      }
    },
    propertyFiltered(row) {
      let data = row.details;
      if (row.filter.trim() != "" && row.filter) {
        data = data.filter((item) => {
          if (item.name.toUpperCase().includes(row.filter.toUpperCase())) {
            return item.name.toUpperCase().includes(row.filter.toUpperCase());
          } else if (
            item.propertyNumber.toUpperCase().includes(row.filter.toUpperCase())
          ) {
            return item.propertyNumber
              .toUpperCase()
              .includes(row.filter.toUpperCase());
          } else if (
            item.serialNumber.toUpperCase().includes(row.filter.toUpperCase())
          ) {
            return item.serialNumber
              .toUpperCase()
              .includes(row.filter.toUpperCase());
          } else if (
            item.currentAssignment &&
            item.currentAssignment.assignmentNumber
              .toUpperCase()
              .includes(row.filter.toUpperCase())
          ) {
            return item.currentAssignment.assignmentNumber
              .toUpperCase()
              .includes(row.filter.toUpperCase());
          }
        });
      }
      return data;
    },
    propertyRows(row) {
      if (row.filter.trim() != "" && row.filter) {
        return this.propertyFiltered(row).length;
      } else {
        return row.details.length;
      }
    },
    onCreateItem() {
      this.getByPo();
    },
    onUpdateItem(props) {
      props.visible = false;
      props.itemVisible = false;
      props.assignmentHistory = [];
      props.assignVisible = false;
      props.assignLoading = false;
      props.attachmentVisible = false;
      props.addDocu = false;
      props.attachmentLoading = false;
      props.fileSearch = "";
      this.tableData[this.poIndex].details.splice(
        this.propertyindex,
        1,
        props
      );
    },
    addProperty() {
      this.$refs.propertycreate.createProperty();
    },
    updateItem(props) {
      this.poIndex = this.tableData.findIndex(
        (item) => item.poNumber == props.poNumber
      );
      this.propertyindex = this.tableData[this.poIndex].details.findIndex(
        (item) => item.id == props.id
      );
      this.$refs.propertycreate.updateProperty(props.id);
    },
    downloadExcelTemplate() {
      const s2ab = (s) => {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i < s.length; i++) {
          view[i] = s.charCodeAt(i) & 0xff;
        }
        return buf;
      };
      this.$swal({
        title: "Are you sure?",
        text: "You want to download the template?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, download it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          let wb = XLSX.utils.book_new();
          wb.Props = {
            Title: "Property Template",
            Subject: "For Uploading",
            Author: "GIAMS Website",
            CreatedDate: new Date()
          };
          wb.SheetNames.push("Sheet 1");
          let ws_data = [
            [
              "IsParent",
              "ParentId",
              "PoNumber",
              "Supplier",
              "FundSource",
              "FundClusterId",
              "AssignmentNumber",
              "ItemCategoryId",
              "Unit",
              "Name",
              "PropertyNumber",
              "DateAcquired",
              "Amount",
              "WarrantyStartDate",
              "WarrantyEndDate",
              "LifespanInYears",
              "YearlyDepreciation",
              "SalvageValue",
              "SerialNumber",
              "Brand",
              "Model",
              "Specification",
              "Color",
              "DimensionDescription",
              "MaterialUsed",
              "PackageDescription",
              "Condition",
              "Note",
              "EmployeeId",
              "LocationId",
              "DateAssigned",
              "RenewalDate",
              "AssignmentType",
              "AssignNotes"
            ]
          ];
          let ws = XLSX.utils.aoa_to_sheet(ws_data);
          wb.Sheets["Sheet 1"] = ws;

          let wbout = XLSX.write(wb, {
            bookType: "xlsx",
            type: "binary"
          });
          saveAs(
            new Blob([s2ab(wbout)], {
              type: "application/octet-stream"
            }),
            "Property_Template.xlsx"
          );
        }
      });
    },
    renderExcel(event) {
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: "binary" });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws);
          const excellist = [];
          for (var i = 0; i < data.length; i++) {
            excellist.push(data[i]);
          }
          this.excelList = excellist;
        };
        reader.readAsBinaryString(this.file);
      }
    },
    checkExcelLabel(row) {
      var labels = [
        "IsParent",
        "ParentId",
        "PoNumber",
        "Supplier",
        "FundSource",
        "FundClusterId",
        "AssignmentNumber",
        "ItemCategoryId",
        "Unit",
        "Name",
        "PropertyNumber",
        "DateAcquired",
        "Amount",
        "WarrantyStartDate",
        "WarrantyEndDate",
        "LifespanInYears",
        "YearlyDepreciation",
        "SalvageValue",
        "SerialNumber",
        "Brand",
        "Model",
        "Specification",
        "Color",
        "DimensionDescription",
        "MaterialUsed",
        "PackageDescription",
        "Condition",
        "Note",
        "EmployeeId",
        "LocationId",
        "DateAssigned",
        "RenewalDate",
        "AssignmentType",
        "AssignNotes"
      ];
      var error = row.filter((f) => !labels.includes(f));
      if (error.length > 0) return true;
      else return false;
    },
    checkExcelData(row) {
      var error = false;
      this.errorData = "";
      if (
        !row.ItemCategoryId ||
        row.ItemCategoryId.toString().trim() == "" ||
        isNaN(parseFloat(row.ItemCategoryId.toString().trim()))
      ) {
        if (this.errorData == "") {
          this.errorData = "ItemCategoryId";
        } else {
          this.errorData = this.errorData
            .toString()
            .concat(", ", "ItemCategoryId");
        }
        error = true;
      }
      if (
        !this.ExcelDateToJSDate(row.DateAcquired) ||
        (row.DateAcquired &&
          row.DateAcquired.toString().trim() != "" &&
          this.ExcelDateToJSDate(row.DateAcquired) == "Invalid Date")
      ) {
        if (isNaN(new Date(row.DateAcquired))) {
          if (this.errorData == "") {
            this.errorData = "DateAcquired";
          } else {
            this.errorData = this.errorData
              .toString()
              .concat(", ", "DateAcquired");
          }
          error = true;
        }
      }
      if (
        !this.ExcelDateToJSDate(row.WarrantyStartDate) ||
        (row.WarrantyStartDate &&
          row.WarrantyStartDate.toString().trim() != "" &&
          this.ExcelDateToJSDate(row.WarrantyStartDate) == "Invalid Date")
      ) {
        if (isNaN(new Date(row.WarrantyStartDate))) {
          if (this.errorData == "") {
            this.errorData = "WarrantyStartDate";
          } else {
            this.errorData = this.errorData
              .toString()
              .concat(", ", "WarrantyStartDate");
          }
          error = true;
        }
      }
      if (
        !this.ExcelDateToJSDate(row.WarrantyEndDate) ||
        (row.WarrantyEndDate &&
          row.WarrantyEndDate.toString().trim() != "" &&
          this.ExcelDateToJSDate(row.WarrantyEndDate) == "Invalid Date")
      ) {
        if (isNaN(new Date(row.WarrantyEndDate))) {
          if (this.errorData == "") {
            this.errorData = "WarrantyEndDate";
          } else {
            this.errorData = this.errorData
              .toString()
              .concat(", ", "WarrantyEndDate");
          }
          error = true;
        }
      }
      if (row.EmployeeId && row.EmployeeId.toString().trim() != "") {
        if (
          !row.LocationId ||
          row.LocationId.toString().trim() == "" ||
          isNaN(parseFloat(row.LocationId.toString().trim())) ||
          row.LocationId == "CLE"
        ) {
          if (this.errorData == "") {
            this.errorData = "LocationId";
          } else {
            this.errorData = this.errorData
              .toString()
              .concat(", ", "LocationId");
          }
          error = true;
        }
        if (
          !this.ExcelDateToJSDate(row.DateAssigned) ||
          (row.DateAssigned &&
            row.DateAssigned.toString().trim() != "" &&
            this.ExcelDateToJSDate(row.DateAssigned) == "Invalid Date")
        ) {
          if (isNaN(new Date(row.DateAssigned))) {
            if (this.errorData == "") {
              this.errorData = "DateAssigned";
            } else {
              this.errorData = this.errorData
                .toString()
                .concat(", ", "DateAssigned");
            }
            error = true;
          }
        }
        if (
          !this.ExcelDateToJSDate(row.RenewalDate) ||
          (row.RenewalDate &&
            row.RenewalDate.toString().trim() != "" &&
            this.ExcelDateToJSDate(row.RenewalDate) == "Invalid Date")
        ) {
          if (isNaN(new Date(row.RenewalDate))) {
            if (this.errorData == "") {
              this.errorData = "RenewalDate";
            } else {
              this.errorData = this.errorData
                .toString()
                .concat(", ", "RenewalDate");
            }
            error = true;
          }
        }
      }
      return error;
    },
    uploadExcel() {
      var errorLabel = false;
      var errorData = false;
      var errorRow = null;
      this.errorData = "";
      var uploadArray = [];
      if (this.excelList.length == 0) {
        this.showToast("No data to upload!", "warning");
        return;
      }
      try {
        this.excelList.forEach((item) => {
          // Check Label
          errorLabel = this.checkExcelLabel(Object.keys(item));

          // Check Data
          errorRow = item;
          errorData = this.checkExcelData(item);

          // Break Loop if Data is Invalid 
          console.log(`Row ${item.__rowNum__ + 1}:`);
          console.log(errorData);
          if (errorLabel || errorData) return;

          // Set Value
          var propertyAssignments = [];
          if (item.DateAcquired) {
            item.DateAcquired = !isNaN(
              this.ExcelDateToJSDate(item.DateAcquired)
            )
              ? this.ExcelDateToJSDate(item.DateAcquired)
              : new Date(item.DateAcquired);
          }
          if (item.WarrantyStartDate) {
            item.WarrantyStartDate = !isNaN(
              this.ExcelDateToJSDate(item.WarrantyStartDate)
            )
              ? this.ExcelDateToJSDate(item.WarrantyStartDate)
              : new Date(item.WarrantyStartDate);
          }
          if (item.WarrantyEndDate) {
            item.WarrantyEndDate = !isNaN(
              this.ExcelDateToJSDate(item.WarrantyEndDate)
            )
              ? this.ExcelDateToJSDate(item.WarrantyEndDate)
              : new Date(item.WarrantyEndDate);
          }
          if (item.DateAssigned) {
            item.DateAssigned = !isNaN(
              this.ExcelDateToJSDate(item.DateAssigned)
            )
              ? this.ExcelDateToJSDate(item.DateAssigned)
              : new Date(item.DateAssigned);
          }
          if (item.renewalDate) {
            item.renewalDate = !isNaN(this.ExcelDateToJSDate(item.renewalDate))
              ? this.ExcelDateToJSDate(item.renewalDate)
              : new Date(item.renewalDate);
          }
          if (
            item.EmployeeId != null &&
            item.EmployeeId.toString().trim() != ""
          ) {
            propertyAssignments.push({
              propertyId: 0,
              employeeIdNumber:
                item.EmployeeId && item.EmployeeId.toString().trim() != ""
                  ? item.EmployeeId.toString().trim()
                  : "",
              propertyLocationId:
                item.LocationId && item.LocationId.toString().trim() != ""
                  ? item.LocationId.toString().trim()
                  : 0,
              assignNotes:
                item.AssignNotes && item.AssignNotes.toString().trim() != ""
                  ? item.AssignNotes.toString()
                  : "",
              assignmentType:
                item.AssignmentType &&
                item.AssignmentType.toString().trim() != ""
                  ? item.AssignmentType.toString().trim()
                  : "New",
              assignmentNumber:
                item.AssignmentNumber &&
                item.AssignmentNumber.toString().trim() != ""
                  ? item.AssignmentNumber.toString().trim()
                  : "",
              dateAssigned: item.DateAssigned
                ? this.getDate(new Date(item.DateAssigned))
                : "0001-01-01T00:00:00",
              renewalDate: item.RenewalDate
                ? this.getDate(new Date(item.RenewalDate))
                : "0001-01-01T00:00:00"
            });
          }
          uploadArray.push({
            isParent: item.IsParent ? true : false,
            parentPropertyId: item.ParentId && item.ParentId.toString().trim() != ""
              ? item.ParentId.toString().trim()
              : 0,
            poNumber:
              item.PoNumber && item.PoNumber.toString().trim() != ""
                ? item.PoNumber.toString().trim()
                : "Not Indicated",
            supplier:
              item.Supplier && item.Supplier.toString().trim() != ""
                ? item.Supplier.toString().trim()
                : "Not Indicated",
            fundCluster:
              item.FundSource && item.FundSource.toString().trim() != ""
                ? item.FundSource.toString().trim()
                : "",
            fundClusterId:
              item.FundClusterId && item.FundClusterId.toString().trim() != ""
                ? item.FundClusterId.toString().trim()
                : 0,
            itemCategoryId:
              item.ItemCategoryId && item.ItemCategoryId.toString().trim() != ""
                ? item.ItemCategoryId.toString().trim()
                : 0,
            unit:
              item.Unit && item.Unit.toString().trim() != ""
                ? item.Unit.toString().trim()
                : "Not Indicated",
            name:
              item.Name && item.Name.toString().trim() != ""
                ? item.Name.toString().trim()
                : item.PoNumber && item.PoNumber.toString().trim() != ""
                ? item.PoNumber.toString().trim()
                : "Not Indicated",
            propertyNumber:
              item.PropertyNumber && item.PropertyNumber.toString().trim() != ""
                ? item.PropertyNumber.toString().trim()
                : "Not Indicated",
            dateAcquired: item.DateAcquired
              ? this.getDate(new Date(item.DateAcquired))
              : "0001-01-01T00:00:00",
            warrantyStartDate: item.WarrantyStartDate
              ? this.getDate(new Date(item.WarrantyStartDate))
              : "0001-01-01T00:00:00",
            warrantyEndDate: item.WarrantyEndDate
              ? this.getDate(new Date(item.WarrantyEndDate))
              : "0001-01-01T00:00:00",
            amount:
              item.Amount && item.Amount.toString().trim() != ""
                ? item.Amount.toString().trim()
                : 0,
            lifespanInYears:
              item.LifespanInYears &&
              item.LifespanInYears.toString().trim() != ""
                ? item.LifespanInYears.toString().trim()
                : 0,
            yearlyDepreciation:
              item.YearlyDepreciation &&
              item.YearlyDepreciation.toString().trim() != ""
                ? item.YearlyDepreciation.toString().trim()
                : 0,
            salvageValue:
              item.SalvageValue && item.SalvageValue.toString().trim() != ""
                ? item.SalvageValue.toString().trim()
                : 0,
            serialNumber:
              item.SerialNumber && item.SerialNumber.toString().trim() != ""
                ? item.SerialNumber.toString().trim()
                : "",
            brand:
              item.Brand && item.Brand.toString().trim() != ""
                ? item.Brand.toString().trim()
                : "",
            model:
              item.Model && item.Model.toString().trim() != ""
                ? item.Model.toString().trim()
                : "",
            specification:
              item.Specification && item.Specification.toString().trim() != ""
                ? item.Specification.toString().trim()
                : "",
            color:
              item.Color && item.Color.toString().trim() != ""
                ? item.Color.toString().trim()
                : "",
            dimensionDescription:
              item.DimensionDescription &&
              item.DimensionDescription.toString().trim() != ""
                ? item.DimensionDescription.toString().trim()
                : "",
            materialUsed:
              item.MaterialUsed && item.MaterialUsed.toString().trim() != ""
                ? item.MaterialUsed.toString().trim()
                : "",
            packageDescription:
              item.PackageDescription &&
              item.PackageDescription.toString().trim() != ""
                ? item.PackageDescription.toString().trim()
                : "",
            condition:
              item.Condition && item.Condition.toString().trim() != ""
                ? item.Condition.toString().trim()
                : "New",
            note:
              item.Note && item.Note.toString().trim() != ""
                ? item.Note.toString()
                : "",
            supplierId: 0,
            iarItemId: 0,
            requisitionItemId: 0,
            propertyAssignments: propertyAssignments ? propertyAssignments : []
          });
        });
        // Break Try
        if (errorLabel || errorData) return;
        this.$store
          .dispatch("property/CreatePropertyMultiple", {
            campusId: this.$store.state.data.selectedCampus.id,
            data: uploadArray
          })
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.getByPo();
            this.$bvModal.hide("modal-excel");
            this.showToast("Successfully uploaded!", "success");
          })
          .catch(() => {
            this.showToast(
              "Something went wrong - Uploading excel data!",
              "error"
            );
          });
      } catch (error) {
        this.$bvModal.hide("modal-excel");
        this.tableBusy = false;
        this.$swal({
          text: `"${this.errorData}" from row "${errorRow.__rowNum__ +
            1}" is missing / does not match the proper format.`,
          icon: "warning",
          confirmButtonColor: "#5c636a",
          confirmButtonText: "Close",
          allowOutsideClick: false
        });
      } finally {
        this.$bvModal.hide("modal-excel");
        this.tableBusy = false;
        if (errorLabel) {
          this.$swal({
            text: `Some "labels" are missing / does not match the proper format.`,
            icon: "warning",
            confirmButtonColor: "#5c636a",
            confirmButtonText: "Close",
            allowOutsideClick: false
          });
        } else if (errorData) {
          this.$swal({
            text: `"${this.errorData}" from row "${errorRow.__rowNum__ +
              1}" is missing / does not match the proper format.`,
            icon: "warning",
            confirmButtonColor: "#5c636a",
            confirmButtonText: "Close",
            allowOutsideClick: false
          });
        }
      }
    },
    ExcelDateToJSDate(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);

      var fractional_day = serial - Math.floor(serial) + 0.0000001;

      var total_seconds = Math.floor(86400 * fractional_day);

      var seconds = total_seconds % 60;

      total_seconds -= seconds;

      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;

      return new Date(
        date_info.getFullYear(),
        date_info.getMonth(),
        date_info.getDate(),
        hours,
        minutes,
        seconds
      );
    },
    uploadProperty() {
      this.$bvModal.show("modal-excel");
    },
    postItem(props) {
      this.poIndex = this.tableData.findIndex(
        (item) => item.poNumber == props.poNumber
      );
      this.propertyindex = this.tableData[this.poIndex].details.findIndex(
        (item) => item.id == props.id
      );
      this.$swal({
        title: "Are you sure?",
        text: "You are about to post this property.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, post it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("property/PostProperty", props.id)
            .then(() => {
              this.tableData[this.poIndex].details.splice(
                this.propertyindex,
                1
              );
              if (this.tableData[this.poIndex].details.length == 0)
                this.tableData.splice(this.poIndex, 1);
              this.showToast("Successfully Posted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be Posted!", "error");
            });
        }
      });
    },
    postMultiple(props) {
      this.poIndex = this.tableData.findIndex(
        (item) => item.poNumber == props.poNumber
      );
      var propertyIds = [];
      props.details.forEach((item) => {
        if (item.toggleSelected === true) {
          propertyIds.push(item.id);
        }
      });
      this.$swal({
        title: "Are you sure?",
        text: `${propertyIds.length} ${
          propertyIds.length > 1 ? "properties" : "property"
        } selected.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, post it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("property/PostMultipleProperty", propertyIds)
            .then((res) => {
              propertyIds.forEach((id) => {
                var index = this.tableData[this.poIndex].details.findIndex(
                  (item) => item.id == id
                );
                this.tableData[this.poIndex].details.splice(index, 1);
              });
              if (this.tableData[this.poIndex].details.length == 0)
                this.tableData.splice(this.poIndex, 1);
              this.showToast("Successfully Posted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be Posted!", "error");
            });
        }
      });
    },
    deleteItem(array, parent) {
      this.poIndex = this.tableData.findIndex((item) => item.poNumber == parent.poNumber);
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false
      }).then(async (result) => {
        if (result.isConfirmed) {
          let err = 0;
          try{
            for (const item of array) {
              const {data: response} = await this.$store.dispatch("property/DeleteProperty", item.id);
              if (response.error) {
                err++;
                return this.showToast(response.errorMessage, "error");
              }
              let index = parent.details.findIndex((i) => i.id == item.id);
              if (index !== -1) {
                parent.details.splice(index, 1);
              }
            }
          }catch(error){
            console.log(error);
            err++;
            this.showToast("Cannot be deleted!", "error");
          }
          if (err == 0) {
            if (parent.details.length == 0) {
              this.tableData.splice(this.poIndex, 1);
            }
            this.showToast("Successfully deleted!", "success");
          }
        }
      });
    },
    returnToTable() {
      this.nextPage = false;
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    },
    getFundCluster() {
      this.$refs.fundcluster.getData();
      this.$bvModal.show("fund-cluster-modal");
    },
    dropFundCluster(data) {
      this.$refs.propertycreate.dropFundCluster(data);
    },
    getItemCategory() {
      this.$refs.itemcategory.filterPropertyCategory();
      this.$bvModal.show("item-category-modal");
    },
    dropItemCat(data) {
      this.$refs.propertycreate.dropItemCat(data);
    },
    getSupplier() {
      this.$bvModal.show("supplier-modal");
    },
    dropSupplier(data) {
      this.$refs.propertycreate.dropSupplier(data);
    },
    removeSupplier() {
      this.form.supplierId = 0;
      this.form.supplier = "";
    },
    getUnit() {
      this.$refs.unit.getData();
      this.$bvModal.show("unit-modal");
    },
    dropUnit(data) {
      this.$refs.propertycreate.dropUnit(data);
    },
    getEmployee(type) {
      this.$refs.employee.resetData();
      this.$bvModal.show("externalEmployee-modal");
      this.getEmployeeType = type;
    },
    dropEmployee(data) {
      if (this.getEmployeeType == "create-modal") {
        this.$refs.propertycreate.dropEmployee(data);
      } else {
        this.assignmentHistoryEmployeeData = data;
      }
    },
    getLocation(type) {
      this.getLocationType = type;
      this.$refs.location.getData(this.campusId);
      this.$bvModal.show("location-modal");
    },
    dropLocation(data) {
      if (this.getLocationType == "create-modal") {
        this.$refs.propertycreate.dropEmployee(data);
      } else {
        this.assignmentHistoryLocationData = data;
      }
    },
    showDtls(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      if (row.item.showDetails) {
        row.item.showDetails = !row.item.showDetails;
        setTimeout(() => {
          row.toggleDetails();
        }, 600);
      } else {
        row.toggleDetails();
        setTimeout(() => {
          row.item.showDetails = !row.item.showDetails;
        }, 50);
      }
    },
    toggleAll(row, propertyRow, currentPage, perPage) {
      row.details.forEach((item) => {
        item.toggleSelected = false;
      });
      if (row.toggleAll === true) {
        propertyRow.sort((a, b) => a.id - b.id);
        var total = currentPage * perPage;
        var currentData = propertyRow.slice(total - perPage, total);
        if (currentPage > 1 && currentData.length == 0) {
          total = (currentPage - 1) * perPage;
          currentData = propertyRow.slice(total - perPage, total);
        }
        currentData.forEach((item) => {
          item.toggleSelected = true;
        });
      }
    },
    checkToggle(row, propertyRow, currentPage, perPage) {
      propertyRow.sort((a, b) => a.id - b.id);
      var total = currentPage * perPage;
      var currentData = propertyRow.slice(total - perPage, total);
      if (currentPage > 1 && currentData.length == 0) {
        total = (currentPage - 1) * perPage;
        currentData = propertyRow.slice(total - perPage, total);
      }
      var count = 0;
      currentData.forEach((item) => {
        if (item.toggleSelected) count++;
      });
      if (count === currentData.length) {
        row.toggleAll = true;
      } else {
        row.toggleAll = false;
      }
    },
    resetToggle(row) {
      row.toggleAll = false;
      row.details.forEach((item) => {
        item.toggleSelected = false;
      });
    },
    resetAllToggle() {
      this.tableData.forEach((row) => {
        row.toggleAll = false;
        row.details.forEach((item) => {
          item.toggleSelected = false;
        });
      });
    },
    selectedRowCheck(items) {
      var count = 0;
      items.forEach((item) => {
        item.toggleSelected && count++;
      });
      if (count > 0) return true;
      else return false;
    },
    selectedItems(items) {
      var selected = [];
      items.forEach((item) => {
        if (item.toggleSelected) selected.push(item);
      });
      return selected;
    },
    propertyNumberWidth(number) {
      if (number < 100) return "min-width: 35px";
      else if (number < 1000) return "min-width: 50px";
      else if (number < 10000) return "min-width: 60px";
      else return "min-width: 75px";
    }
  }
};
</script>

<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <!-- View Employee Info -->
    <b-modal
      id="modal-accountableEmployee"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <div v-if="accountableEmployee && accountableEmployee.firstName">
        <div class="d-flex align-items-center">
          <div class="avatar-sm me-2">
            <span
              class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-16"
              >{{ accountableEmployee.firstName.charAt(0).toUpperCase()
              }}{{ accountableEmployee.lastName.charAt(0).toUpperCase() }}</span
            >
          </div>
          <div>
            <div class="mt-1">
              <h5 class="mb-0">
                {{
                  accountableEmployee.lastName.charAt(0).toUpperCase() +
                    accountableEmployee.lastName.slice(1)
                }},
                {{
                  accountableEmployee.firstName.charAt(0).toUpperCase() +
                    accountableEmployee.firstName.slice(1)
                }}
                {{
                  accountableEmployee.middleName
                    ? `${accountableEmployee.middleName
                        .charAt(0)
                        .toUpperCase()}.`
                    : ""
                }}
              </h5>
            </div>
            <div>{{ accountableEmployee.idNo }}</div>
          </div>
        </div>
        <hr class="my-3" />
        <div class="ps-3 pe-3">
          <b-row class="mb-2">
            <b-col class="p-0" sm="2">
              <b>Office</b>
            </b-col>
            <b-col
              :class="{
                'text-white': accountableEmployee.office
              }"
              >{{
                accountableEmployee.office
                  ? accountableEmployee.office
                  : "No record"
              }}</b-col
            >
          </b-row>
          <b-row class="mb-2">
            <b-col class="p-0" sm="2">
              <b>Position</b>
            </b-col>
            <b-col
              :class="{
                'text-white': accountableEmployee.position
              }"
              >{{
                accountableEmployee.position
                  ? accountableEmployee.position
                  : "No record"
              }}</b-col
            >
          </b-row>
        </div>
        <hr class="my-3" />
      </div>
    </b-modal>
    <!-- Upload Excel -->
    <b-modal
      id="modal-excel"
      title="Upload Excel"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form class="needs-validation" ref="usForm">
        <div class="input-group">
          <input
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            class="form-control"
            id="inputGroupFile04"
            aria-describedby="inputGroupFileAddon04"
            aria-label="Upload"
            @change="renderExcel"
          />
        </div>
        <div class="d-flex flex-row-reverse">
          <button
            class="btn btn-primary mt-3"
            type="button"
            id="inputGroupFileAddon04"
            @click="uploadExcel"
          >
            Upload
          </button>
        </div>
      </form>
    </b-modal>
    <!-- Main -->
    <div
      class="card border-4 border-top border-start-0 border-end-0 border-primary"
    >
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="d-flex align-items-center h-100">
              <h5 class="mb-0 mt-2">List of Pending Properties</h5>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex align-items-center float-end">
              <button
                type="button"
                @click="addProperty()"
                class="btn btn-sm btn-primary d-flex align-items-center ms-1"
              >
                <i class="bx bx-plus fs-6 me-1"></i>Create Property
              </button>
              <button
                type="button"
                @click="uploadProperty()"
                class="btn btn-sm btn-success d-flex align-items-center ms-1"
              >
                <i class="bx bx-upload fs-6 me-1"></i>Upload Property
              </button>
              <button
                type="button"
                @click="downloadExcelTemplate()"
                class="btn btn-sm btn-info d-flex align-items-center ms-1"
              >
                <i class="bx bx-download fs-6 me-1"></i>Download Excel Template
              </button>
            </div>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-md-6"></div>
          <div class="col-md-6">
            <div class="d-flex float-end">
              <div id="tickets-table_filter" class="dataTables_filter me-1">
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    @input="
                      currentPage = 1;
                      resetAllToggle();
                    "
                    placeholder="Search PO..."
                    class="form-control"
                  ></b-form-input>
                </label>
              </div>
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center mb-0">
                  <b-form-select
                    class="form-select"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptionsLg"
                  >
                  </b-form-select>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="custom-table-responsive mb-0 mt-2">
          <b-table
            class="propertyTable datatables target-table"
            :items="filtered"
            :fields="fields"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            :busy="tableBusy"
            bordered
            striped
            show-empty
          >
            <template #empty>
              <b-card-header>
                <div class="text-center">
                  <div v-if="filter != ''">
                    <i class="fas fa-exclamation-triangle me-2"></i>There are no
                    POs matching your request
                  </div>
                  <div v-else>
                    <i class="fas fa-exclamation-triangle me-2"></i>No POs
                    available
                  </div>
                </div>
              </b-card-header>
            </template>
            <template #table-busy>
              <b-card-header>
                <div class="d-flex justify-content-center align-items-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </b-card-header>
            </template>
            <template #cell(poNumber)="row">
              <b-card-header
                header-tag="header"
                @click="getProperty(row)"
                class="cursor-pointer border position-relative"
                role="tab"
              >
                <RawData :data="row.item" v-if="$store.state.decrypt.isAdmin()" :exclude="['details']"/>
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <b class="text-white">{{
                      row.value ? `PO# ${row.value}` : "No Recorded PO"
                    }}</b>
                    <div>
                      {{
                        row.item.supplier
                          ? row.item.supplier
                          : "No Recorded Supplier"
                      }}
                    </div>
                  </div>
                  <div>
                    <i
                      class="bx bx-chevron-right rotate font-size-16 cursor-pointer"
                      :class="{
                        'rotate-90': row.item.rotateChevy
                      }"
                    ></i>
                  </div>
                </div>
              </b-card-header>
              <b-collapse :visible="row.item.showDetails">
                <div v-if="row.item.showDetails">
                  <b-card
                    no-body
                    class="p-3 shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0"
                  >
                    <div class="d-flex justify-content-between mb-1">
                      <div class="d-flex align-items-center">
                        <div class="p-1 pe-0">
                          <div
                            class="form-check form-checkbox-outline form-check-success"
                          >
                            <input
                              type="checkbox"
                              :id="
                                `checkbox-${row.item.poNumber}-${row.item.supplier}`
                              "
                              checked="checked"
                              class="form-check-input"
                              @change="
                                toggleAll(
                                  row.item,
                                  propertyFiltered(row.item),
                                  row.item.currentPage,
                                  row.item.perPage
                                )
                              "
                              v-model="row.item.toggleAll"
                            /><label
                              :for="
                                `checkbox-${row.item.poNumber}-${row.item.supplier}`
                              "
                              class="form-check-label"
                            >
                              Select Current Page
                            </label>
                          </div>
                        </div>
                        <div class="d-flex align-items-center ms-3">
                          <div>|</div>
                          <transition>
                            <div class="d-flex gap-1" v-if="selectedRowCheck(row.item.details) && row.item.showDetails">
                              <button
                                type="button"
                                class="btn btn-sm btn-success ms-3 d-flex align-items-center"
                                @click="postMultiple(row.item)"
                              >
                                <i class="bx bx-check-circle fs-6 me-1"></i>
                                Post Properties
                              </button>
                              <button
                                v-if="!row.item.fromPO"
                                type="button"
                                class="btn btn-sm btn-danger d-flex align-items-center"
                                @click="deleteItem(selectedItems(row.item.details), row.item)"
                              >
                                <i class="bx bx-trash fs-6 me-1"></i>
                                Delete Properties
                              </button>
                            </div>
                          </transition>
                        </div>
                      </div>
                      <div class="d-flex">
                        <div
                          id="tickets-table_filter"
                          class="dataTables_filter me-1"
                        >
                          <label class="d-inline-flex align-items-center">
                            <b-form-input
                              autocomplete="off"
                              @input="resetToggle(row.item)"
                              v-model="row.item.filter"
                              type="search"
                              placeholder="Search Property..."
                              class="form-control form-control-sm"
                            ></b-form-input>
                          </label>
                        </div>
                        <div
                          id="tickets-table_length"
                          class="dataTables_length"
                        >
                          <label class="d-inline-flex align-items-center mb-0">
                            <b-form-select
                              class="form-select form-select-sm"
                              v-model="row.item.perPage"
                              size="sm"
                              :options="pageOptionsSm"
                            >
                            </b-form-select>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="mb-0">
                      <b-table
                        class="propertyTable datatables target-table"
                        thead-class="d-none"
                        :items="propertyFiltered(row.item)"
                        :fields="propertyFields"
                        responsive="sm"
                        :per-page="row.item.perPage"
                        :current-page="row.item.currentPage"
                        sort-by="id"
                        :sort-desc="false"
                        :busy="row.item.tableBusy"
                        show-empty
                      >
                        <template #empty>
                          <b-card-header>
                            <div class="text-center">
                              <div v-if="row.item.filter != ''">
                                <i class="fas fa-exclamation-triangle me-2"></i
                                >There are no properties matching your request
                              </div>
                              <div v-else>
                                <i class="fas fa-exclamation-triangle me-2"></i
                                >No properties available
                              </div>
                            </div>
                          </b-card-header>
                        </template>
                        <template #table-busy>
                          <b-card-header>
                            <div
                              class="d-flex justify-content-center align-items-center p-2"
                            >
                              <div class="preloader-component me-2">
                                <div class="status">
                                  <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                  </div>
                                </div>
                              </div>
                              <strong>Loading...</strong>
                            </div>
                          </b-card-header>
                        </template>
                        <template #cell(name)="propertyRow">
                          <div class="position-relative ms-1">
                            <RawData
                              :data="propertyRow.item"
                              v-if="$store.state.decrypt.isAdmin()"
                            />
                          </div>
                          <b-card-header
                            header-tag="header"
                            role="tab"
                            class="border"
                          >
                            <div
                              class="d-flex justify-content-between align-items-center"
                            >
                              <div class="d-flex align-items-center pe-5">
                                <div
                                  style="width: 25px"
                                  class="form-check form-checkbox-outline form-check-success me-2"
                                >
                                  <input
                                    type="checkbox"
                                    :id="`apiID-${propertyRow.item.id}`"
                                    class="form-check-input"
                                    @change="
                                      checkToggle(
                                        row.item,
                                        propertyFiltered(row.item),
                                        row.item.currentPage,
                                        row.item.perPage
                                      )
                                    "
                                    v-model="propertyRow.item.toggleSelected"
                                  />
                                </div>
                                <div
                                  :style="
                                    propertyNumberWidth(
                                      (currentPage - 1) * perPage +
                                        (propertyRow.index + 1)
                                    )
                                  "
                                  class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                                >
                                  <h3 class="mb-0 position-relative">
                                    {{
                                      (row.item.currentPage - 1) *
                                        row.item.perPage +
                                        (propertyRow.index + 1)
                                    }}
                                  </h3>
                                </div>
                                <div class="text-muted">
                                  <h5 class="mb-0">
                                    {{ propertyRow.item.name }}
                                  </h5>
                                  <div style="min-width: max-content">
                                    <small class="d-flex align-items-center">
                                      {{
                                        propertyRow.item.propertyNumber &&
                                        propertyRow.item.propertyNumber !=
                                          "Not Indicated"
                                          ? `Property# ${propertyRow.item.propertyNumber}`
                                          : "Not Indicated"
                                      }}
                                      |
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success d-flex align-items-center ms-1"
                                        @click="
                                          propertyRow.item.visible = !propertyRow
                                            .item.visible
                                        "
                                      >
                                        {{
                                          propertyRow.item.visible
                                            ? "Hide"
                                            : "Show"
                                        }}
                                        Details
                                        <i
                                          class="bx bx-chevron-right rotate font-size-14"
                                          :class="{
                                            'rotate-90':
                                              propertyRow.item.visible
                                          }"
                                        ></i>
                                      </a>
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="d-flex justify-content-between align-items-center ms-5"
                              >
                                <div
                                  style="width: 200px"
                                  class="d-flex align-items-center"
                                >
                                  <div class="text-muted">
                                    <div>
                                      <small class="d-flex align-items-center">
                                        Current Value:
                                      </small>
                                    </div>
                                    <h6 class="mb-0 text-warning">
                                      {{
                                        formatCurrency(
                                          propertyRow.item.currentValue
                                        )
                                      }}
                                    </h6>
                                  </div>
                                </div>
                                <div
                                  class="float-end d-flex align-items-center ms-3"
                                >
                                  <i
                                    class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                                    :id="
                                      `register-popover-${propertyRow.item.id}`
                                    "
                                    tabindex="0"
                                  ></i>
                                  <b-popover
                                    :target="
                                      `register-popover-${propertyRow.item.id}`
                                    "
                                    triggers="click blur"
                                    placement="leftbottom"
                                    variant="secondary"
                                    custom-class="p-0"
                                  >
                                    <b-list-group class="w-100 fit">
                                      <b-list-group-item
                                        button
                                        action
                                        class="d-flex align-items-center text-info"
                                        @click="updateItem(propertyRow.item)"
                                        ><i
                                          class="mdi mdi-update font-size-18 me-1"
                                        ></i
                                        >Update Item</b-list-group-item
                                      >
                                      <b-list-group-item
                                        button
                                        action
                                        class="d-flex align-items-center text-success"
                                        @click="postItem(propertyRow.item)"
                                        ><i
                                          class="bx bx-list-check font-size-18 me-1"
                                        ></i
                                        >Post Now</b-list-group-item
                                      >
                                      <b-list-group-item
                                        v-if="!row.item.fromPO"
                                        button
                                        action
                                        class="d-flex align-items-center text-danger"
                                        @click="deleteItem([propertyRow.item], row.item)"
                                        ><i
                                          class="mdi mdi-trash-can font-size-18 me-1"
                                        ></i
                                        >Delete</b-list-group-item
                                      >
                                    </b-list-group>
                                  </b-popover>
                                </div>
                              </div>
                            </div>
                          </b-card-header>
                          <b-collapse
                            :visible="propertyRow.item.visible"
                            role="tabpanel"
                          >
                            <div v-if="propertyRow.item.visible">
                              <b-card
                                no-body
                                class="shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0"
                              >
                                <Details
                                  :key="`details-${propertyRow.item.id}`"
                                  :propertyRow="propertyRow.item"
                                  :ref="`details-${propertyRow.item.id}`"
                                ></Details>
                                <AssignmentHistory
                                  :key="`assignment-${propertyRow.item.id}`"
                                  :propertyRow="propertyRow.item"
                                  :allowAssign="false"
                                  :allowEdit="true"
                                  :allowTransfer="true"
                                  :employeeData="assignmentHistoryEmployeeData"
                                  :locationData="assignmentHistoryLocationData"
                                  :ref="`assignment-${propertyRow.item.id}`"
                                  @getEmployee="getEmployee($event)"
                                  @getLocation="getLocation($event)"
                                ></AssignmentHistory>
                                <Attachments
                                  :key="`attachments-${propertyRow.item.id}`"
                                  :propertyRow="propertyRow.item"
                                  :ref="`attachments-${propertyRow.item.id}`"
                                ></Attachments>
                              </b-card>
                            </div>
                          </b-collapse>
                        </template>
                      </b-table>
                    </div>
                    <div class="row">
                      <div v-if="propertyRows(row.item) > 0" class="col">
                        Showing
                        {{ (row.item.currentPage - 1) * row.item.perPage + 1 }}
                        -
                        {{
                          propertyRows(row.item) >
                          (row.item.currentPage - 1) * row.item.perPage +
                            row.item.perPage
                            ? (row.item.currentPage - 1) * row.item.perPage +
                              row.item.perPage
                            : propertyRows(row.item)
                        }}
                        of {{ propertyRows(row.item) }}
                      </div>
                      <div class="col">
                        <div
                          @click="resetToggle(row.item)"
                          class="dataTables_paginate paging_simple_numbers float-end"
                        >
                          <ul
                            class="pagination pagination-rounded mb-0"
                            style="z-index: -1"
                          >
                            <b-pagination
                              v-model="row.item.currentPage"
                              :total-rows="propertyRows(row.item)"
                              :per-page="row.item.perPage"
                            ></b-pagination>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>
              </b-collapse>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div v-if="rows > 0" class="col">
            Showing {{ (currentPage - 1) * perPage + 1 }} -
            {{
              rows > (currentPage - 1) * perPage + perPage
                ? (currentPage - 1) * perPage + perPage
                : rows
            }}
            of {{ rows }}
          </div>
          <div class="col">
            <div
              @click="resetAllToggle()"
              class="dataTables_paginate paging_simple_numbers float-end"
            >
              <ul
                class="pagination pagination-rounded mb-0"
                style="z-index: -1"
              >
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <fund-cluster
      ref="fundcluster"
      @dropData="dropFundCluster($event)"
    ></fund-cluster>
    <item-category
      ref="itemcategory"
      @dropData="dropItemCat($event)"
    ></item-category>
    <supplier @dropData="dropSupplier($event)"></supplier>
    <unit ref="unit" @dropData="dropUnit($event)"></unit>
    <Employee ref="employee" @dropData="dropEmployee($event)"></Employee>
    <Location ref="location" @dropData="dropLocation($event)"></Location>
    <PropertyCreate 
      ref="propertycreate"
      @createData="onCreateItem($event)"
      @updateData="onUpdateItem($event)"
      @getFundCluster="getFundCluster($event)"
      @getItemCategory="getItemCategory($event)"
      @getSupplier="getSupplier($event)"
      @getUnit="getUnit($event)"
      @getEmployee="getEmployee($event)"
      @getLocation="getLocation($event)"
    ></PropertyCreate>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.tooltip {
  opacity: 1 !important;
}

.v-enter-active {
  animation: slide-in 0.3s;
}

.v-leave-active {
  animation: slide-in 0.3s reverse;
}

@keyframes slide-in {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.propertyTable tr td {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
